"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Facets_1 = require("../entity/Facets");
const defaultValue = {
    industry: {
        buckets: [
            {
                value: 'test_industry',
                count: 7,
            },
            {
                value: 'QAチームです！',
                count: 1,
            },
            {
                value: 'QA非公開',
                count: 1,
            },
            {
                value: 'test_industry3',
                count: 1,
            },
            {
                value: 'テスト',
                count: 1,
            },
            {
                value: '広告業',
                count: 1,
            },
            {
                value: '業種0221',
                count: 1,
            },
            {
                value: '業種テスト',
                count: 1,
            },
            {
                value: '業種テスト2',
                count: 1,
            },
        ],
    },
    height: {
        buckets: [
            {
                value: '360',
                count: 44,
            },
            {
                value: '720',
                count: 14,
            },
            {
                value: '1080',
                count: 9,
            },
            {
                value: '368',
                count: 6,
            },
            {
                value: '320',
                count: 2,
            },
            {
                value: '103',
                count: 1,
            },
            {
                value: '107',
                count: 1,
            },
            {
                value: '183',
                count: 1,
            },
            {
                value: '194',
                count: 1,
            },
            {
                value: '200',
                count: 1,
            },
            {
                value: '444',
                count: 1,
            },
            {
                value: '482',
                count: 1,
            },
            {
                value: '538',
                count: 1,
            },
            {
                value: '664',
                count: 1,
            },
            {
                value: '1920',
                count: 1,
            },
            {
                value: '3024',
                count: 1,
            },
        ],
    },
    width: {
        buckets: [
            {
                value: '640',
                count: 44,
            },
            {
                value: '1280',
                count: 14,
            },
            {
                value: '1920',
                count: 8,
            },
            {
                value: '728',
                count: 6,
            },
            {
                value: '560',
                count: 2,
            },
            {
                value: '1080',
                count: 2,
            },
            {
                value: '109',
                count: 1,
            },
            {
                value: '110',
                count: 1,
            },
            {
                value: '200',
                count: 1,
            },
            {
                value: '207',
                count: 1,
            },
            {
                value: '275',
                count: 1,
            },
            {
                value: '482',
                count: 1,
            },
            {
                value: '978',
                count: 1,
            },
            {
                value: '1182',
                count: 1,
            },
            {
                value: '1200',
                count: 1,
            },
            {
                value: '4032',
                count: 1,
            },
        ],
    },
    tag: {
        buckets: [
            {
                value: 'テストタグ',
                count: 1,
            },
        ],
    },
    contentType: {
        buckets: [
            {
                value: 'video/mp4',
                count: 60,
            },
            {
                value: 'video/quicktime',
                count: 17,
            },
            {
                value: 'image/png',
                count: 7,
            },
            {
                value: 'image/jpeg',
                count: 2,
            },
        ],
    },
    scope: {
        buckets: [
            {
                value: '2',
                count: 85,
            },
            {
                value: '1',
                count: 1,
            },
        ],
    },
    placement: {
        buckets: [
            {
                value: 'facebook',
                count: 20,
            },
            {
                value: 'google',
                count: 5,
            },
            {
                value: 'line',
                count: 2,
            },
            {
                value: 'twitter',
                count: 2,
            },
            {
                value: 'yahoo',
                count: 2,
            },
            {
                value: 'youtube',
                count: 2,
            },
            {
                value: 'instagram',
                count: 1,
            },
        ],
    },
    aspectRatio: {
        buckets: [
            {
                value: '16:9',
                count: 31,
            },
            {
                value: '1:1',
                count: 2,
            },
            {
                value: '9:16',
                count: 1,
            },
        ],
    },
    composition: {
        buckets: [],
    },
    organizationTag: {
        buckets: [
            { value: '組織タグ1', count: 21 },
            { value: '組織タグ2', count: 22 },
        ],
    },
};
const defaultAllFacets = {
    industry: {
        buckets: [
            {
                value: 'test_industry',
                count: 7,
            },
            {
                value: 'QAチームです！',
                count: 1,
            },
            {
                value: 'QA非公開',
                count: 1,
            },
            {
                value: 'test_industry3',
                count: 1,
            },
            {
                value: 'テスト',
                count: 1,
            },
            {
                value: '広告業',
                count: 1,
            },
            {
                value: '業種0221',
                count: 1,
            },
            {
                value: '業種テスト',
                count: 1,
            },
            {
                value: '業種テスト2',
                count: 1,
            },
        ],
    },
    placement: {
        buckets: [
            {
                value: 'facebook',
                count: 20,
            },
            {
                value: 'google',
                count: 5,
            },
            {
                value: 'line',
                count: 2,
            },
            {
                value: 'twitter',
                count: 2,
            },
            {
                value: 'yahoo',
                count: 2,
            },
            {
                value: 'youtube',
                count: 2,
            },
            {
                value: 'instagram',
                count: 1,
            },
        ],
    },
    aspectRatio: {
        buckets: [
            {
                value: '16:9',
                count: 31,
            },
            {
                value: '1:1',
                count: 2,
            },
            {
                value: '9:16',
                count: 1,
            },
        ],
    },
    composition: {
        buckets: [],
    },
    organizationTag: {
        buckets: [
            { value: '組織タグ1', count: 21 },
            { value: '組織タグ2', count: 22 },
        ],
    },
};
exports.generateFacetEntity = (json = defaultValue) => Facets_1.ResultFacets.fromJSON(json);
exports.generateAllFacetEntity = (json = defaultAllFacets) => Facets_1.AllFacets.fromJSON(json);
